import React from "react";
import { Img, Section } from "@react-email/components";
import PropTypes from "prop-types";

const HotelLogo = ({ image = "https://email-assets.lokalee.app/email/emailImages/logo.png" }) => (
  <Section style={{ textAlign: "center", backgroundColor: "#f7fafc" }}>
    <Img
      alt="Logo"
      src={image}
      style={{
        height: "60px",
        maxWidth: "300px",
        margin: "16px auto",
      }}
    />
  </Section>
);

export default HotelLogo;

HotelLogo.propTypes = {
  image: PropTypes.string,
};
